var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9859 6.17676H13.8976C13.329 6.17676 12.8681 6.63767 12.8681 7.20622V10.2946H16.9859C17.103 10.292 17.2141 10.3465 17.2837 10.4407C17.3533 10.5349 17.3728 10.657 17.336 10.7682L16.5742 13.033C16.5039 13.2408 16.3097 13.3813 16.0903 13.383H12.8681V21.104C12.8681 21.3882 12.6376 21.6187 12.3534 21.6187H9.77971C9.49543 21.6187 9.26498 21.3882 9.26498 21.104V13.383H7.72079C7.43651 13.383 7.20605 13.1525 7.20605 12.8683V10.8093C7.20605 10.5251 7.43651 10.2946 7.72079 10.2946H9.26498V7.20622C9.26498 4.932 11.1086 3.08838 13.3828 3.08838H16.9859C17.2702 3.08838 17.5007 3.31883 17.5007 3.60311V5.66203C17.5007 5.94631 17.2702 6.17676 16.9859 6.17676Z",
    fill: "#FFF0F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.e35c8c4e81e8310803dcd459a65f9b0a.svg";
export { ForwardRef as ReactComponent };